import { useQuery } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import endpoints from '../../API/endpoints'
import callAPI from '../../API/callSecureAPI'

const ONE_MINUTE = 1000 * 60
const FIVE_MINUTES = ONE_MINUTE * 5

export type RequiredFields = {
    vm: string[]
    evidence: string[]
    activities: string[]
}

export const useGetRequiredFieldsQuery = (organizationId?: string) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getRequiredFields = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

            const { url, method } = endpoints.getRequiredFields

            const response = await callAPI(url + organizationId, method, token)

            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    return useQuery<RequiredFields>(['requiredFields', organizationId], getRequiredFields, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!organizationId,
        // cacheTime: FIVE_MINUTES,
        // staleTime: FIVE_MINUTES,
    })
}
